module.exports = __webpack_public_path__ + "static/media/forbidden-white.61fa1d08.png";